module.exports = __webpack_public_path__ + "img/memory.bed3ff42.png";